import type { RoundAggregate } from "@engine/round/aggregate";
import {
  runSProcessOnRoundWithMatchingAdjustment,
  type SProcessOutputWithMatchingAdjustment,
} from "@lib/algoInterface/runSProcessOnRound";

// Single-entry cache keyed on round identity (the aggregate is a fresh object
// on every change), mirroring expectedScoresByRecommenderForRound. The round
// context computes the output here after first paint, and useOutput() falls
// back to the same cache for surfaces that need the output synchronously at
// mount — so the algorithm runs at most once per round version no matter who
// asks first.
let cache: {
  round: RoundAggregate;
  value: SProcessOutputWithMatchingAdjustment;
} | null = null;

export function sProcessOutputForRound(
  round: RoundAggregate,
): SProcessOutputWithMatchingAdjustment {
  if (cache?.round === round) {
    return cache.value;
  }
  const value = runSProcessOnRoundWithMatchingAdjustment(round);
  cache = { round, value };
  return value;
}
